import { Component, OnInit } from '@angular/core';
import { GymService } from '../../services/gym.service';
import { Gym } from '../../models/gym';
import { UserService } from '../../services/user.service';
import { MatDialog } from '@angular/material/dialog';
import { AddGymToClassTemplatesComponent } from '../add-gym-to-class-templates/add-gym-to-class-templates.component';

@Component({
  selector: 'app-gym',
  templateUrl: './gym.component.html',
  styleUrls: ['./gym.component.scss']
})
export class GymComponent implements OnInit {

  public ErrorMsg = '';
  public editMode: boolean;

  public listOfGyms: Array<any>;
  public editingGym: Gym;
  public listOfUsers: Array<any>;

  constructor(private gymService: GymService, private userService: UserService, private dialog: MatDialog) { }

  ngOnInit() {
    this.editMode = false;
    this.editingGym = new Gym();
    this.userService.getAllUsers().then((users) => {
      this.listOfUsers = users;
      this.gymService.getAllGyms().then((gyms) => {
        this.listOfGyms = gyms;
      });
    });
  }

  addGym() {
    if (this.editingGym.gymName && this.editingGym.ownedBy && this.editingGym.location) {
      this.gymService.addGym(this.editingGym)
        .subscribe((gym) => {
          const dialogRef = this.dialog.open(AddGymToClassTemplatesComponent, {
            data: {
              gymId: gym._id,
              ownedBy: this.editingGym.ownedBy
            },
          });
          dialogRef.afterClosed().subscribe(result => {
            this.ngOnInit();
          });
        });
    } else {
      this.ErrorMsg = 'Name And Location Are Required.';
    }
  }

  delGym(id) {
    this.gymService.delGym(id)
        .subscribe(() => { this.ngOnInit(); });
  }

  setGymToEdit(gym) {
    this.editMode = true;
    this.editingGym = gym;
    this.editingGym.ownedBy = gym.ownedBy._id;
  }

  editGym() {
    if (this.editingGym.gymName && this.editingGym.ownedBy && this.editingGym.location) {
      this.gymService.editGYm(this.editingGym)
        .subscribe(() => { this.ngOnInit(); });
    } else {
      this.ErrorMsg = 'Name And Location Are Required.';
    }
  }

  quitEditingMode() {
    this.editMode = false;
    this.editingGym = new Gym();
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/components/gym/gym.component.ts